import './App.css';
import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { AuthContext } from './utils/AuthContext';
import PrivateRoutes from './utils/PrivateRoutes'
import Login from './pages/Login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Quotation from './pages/Quotation';
import QuotationList from './pages/QuotationList';
import UserForm from './pages/UserForm';
import InsurerRates from './pages/InsurerRates';
import Profile from './pages/Profile';
import AppFiles from './pages/AppFiles';
import ChangePassword from './pages/ChangePassword';
import { ConfigContext } from './utils/ConfigContext';
import Quotation1 from './pages/Quotation1';
import { Box, Button, Typography } from '@mui/material';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Users from './pages/Users';
import PremiumIncreaseCalculator from './pages/PremiumIncreaseCalculator';
import AutoQuotation from './pages/AutoQuotation';
import MyTobPlans from './pages/MyTobPlans';
import { Outlet } from 'react-router-dom';

function App() {

  const token = localStorage.getItem('quoting-api-token');
  const user = JSON.parse(localStorage.getItem('quoting-current-user'));

  const content = localStorage.getItem('quoting-app-config');
  const configTimestamp = localStorage.getItem('quoting-app-config-timestamp');


  // useEffect(() => {

  // }, []);

  const [auth, setAuth] = useState({
    token,
    user
  });

  let showRefreshConfig = false;

  if (!isJsonString(content)) {
    showRefreshConfig = true;
  }



  const [appConfig, setAppConfig] = useState({
    content: JSON.parse(content),
    configTimestamp
  });

  const subDir = 'quoting';

  function isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  function QuotationWrapper() {
    return <Quotation1 key="new-quotation" />;
  }

  function SavedQuotationWrapper() {
    return <Quotation1 key="saved-quotation" />;
  }

  return (
    <>
      <ConfigContext.Provider value={{ appConfig, setAppConfig }}>
        <AuthContext.Provider value={{ auth, setAuth }}>
          <BrowserRouter basename={subDir}>
            <Routes>
              <Route element={<ForgotPassword />} path='/forgot' />
              <Route element={<ResetPassword />} path='/reset_password' />
              <Route element={<Login />} path='/login' />
              <Route element={<Login />} path='/' />

              <Route element={<PrivateRoutes />}>
                <Route element={<UserForm />} path='/add_user' />
                <Route element={<UserForm />} path='/update_user/:id' />
                <Route element={<Users />} path='/users' />
                <Route element={<QuotationWrapper />} path='/quotation' />
                <Route element={<SavedQuotationWrapper />} path='/saved_quotation' />
                <Route element={<QuotationList />} path='/quotation_list' />
                <Route element={<MyTobPlans />} path='/my_tob_plans' />
                <Route element={<InsurerRates />} path='/insurer_rates' />
                <Route element={<AppFiles />} path='/app_files' />
                <Route element={<Profile />} path='/profile' />
                <Route element={<ChangePassword />} path='/change_password' />
                <Route element={<PremiumIncreaseCalculator />} path='/premium_increase_calculator' />
                <Route element={<AutoQuotation />} path='/auto_quotation' />
                <Route element={<AutoQuotation />} path='/auto_quotation/:id' />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthContext.Provider>
      </ConfigContext.Provider>
      <ToastContainer />
    </>
  );
}

export default App;